import { useQuery } from '@tanstack/react-query'

import type { GooglePlaceDataForHome } from './google-place-reviews.service'

export type GooglePlaceReviewsPayload = GooglePlaceDataForHome & {
	mapsPlaceId: string | null
}

export const googlePlaceReviewsQueryKey = (locale: string) =>
	['google-place-reviews', locale] as const

export function useGooglePlaceReviews(locale: string) {
	return useQuery({
		queryKey: googlePlaceReviewsQueryKey(locale),
		queryFn: async (): Promise<GooglePlaceReviewsPayload | null> => {
			const res = await fetch(
				`/api/google-reviews?locale=${encodeURIComponent(locale)}`,
				{
					cache: 'no-store'
				}
			)

			if (!res.ok) {
				throw new Error('google-place-reviews fetch failed')
			}

			return res.json() as Promise<GooglePlaceReviewsPayload | null>
		},
		retry: 1
	})
}
